import styled from "@emotion/styled";
import type { ReactNode } from "react";

import {
  AgentSurfaceNavigation,
  AgentSurfaceNavigationActiveTab,
} from "@/pages/agent/components/agent-surface-navigation";

export const AgentPageLayout = ({
  activeTab,
  children,
}: {
  activeTab: AgentSurfaceNavigationActiveTab;
  children: ReactNode;
}) => (
  <StyledRoot>
    <AgentSurfaceNavigation activeTab={activeTab} />
    {children}
  </StyledRoot>
);

export const AgentPageFilterBar = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing[2]};
`;

const StyledRoot = styled.div`
  background: ${({ theme }) => theme.colors.surface.onboarding};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[8]};
  min-height: 100%;
  padding: ${({ theme }) => theme.spacing[8]} ${({ theme }) => theme.spacing[10]}
    ${({ theme }) => theme.spacing[10]};
`;
